import { useEffect, useRef } from 'react';

// While the user is actively searching (filters.q non-empty), forces the scope to the
// "broad" one (all requests for an agent, whole company for a customer) so search
// results aren't scoped down to just "mine". Once the query is cleared, restores
// whatever scope was active before the search started — but only if the user hadn't
// manually changed scope themselves while searching (searchAutoScopeRef tracks that).
export function useSearchScopeSync(filters, setFilters, role) {
  const previousScopeRef = useRef('mine');
  const searchAutoScopeRef = useRef(false);

  useEffect(() => {
    const trimmedQuery = filters.q.trim();
    const broadScope = role === 'agent' ? 'all' : 'company';

    if (trimmedQuery) {
      if (filters.scope !== broadScope) {
        previousScopeRef.current = filters.scope || previousScopeRef.current;
        searchAutoScopeRef.current = true;
        setFilters(current => (current.scope === broadScope ? current : { ...current, scope: broadScope }));
      }
      return;
    }

    if (filters.scope !== broadScope) {
      searchAutoScopeRef.current = false;
      previousScopeRef.current = filters.scope;
      return;
    }

    if (searchAutoScopeRef.current && previousScopeRef.current && previousScopeRef.current !== broadScope) {
      setFilters(current => (current.scope === previousScopeRef.current ? current : { ...current, scope: previousScopeRef.current }));
      searchAutoScopeRef.current = false;
    }
  }, [filters.q, filters.scope, role]);
}
